import { userMutationTypes } from './mutation-types';

export const mutations = {
  [userMutationTypes.SET_USER_DATA] (state, user) {
    state.user = user;
  },
  [userMutationTypes.SET_REQUEST_STATUS](state, status) {
    state.requestStatus = status;
  },
  [userMutationTypes.SET_USER_LOGOUT](state) {
    state.stSessionId = '';
  },
};
